module.exports = "<label class=\"switch\">\r\n  <input type=\"checkbox\">\r\n  <span class=\"slider\"></span>\r\n</label>\r\n"